/**
 * StatusTabs — secondary filter tabs for the verification queue.
 *
 * Props:
 *   active    {'pending_verification'|'verified'|'suspended'}
 *   counts    {{ pending_verification: number, verified: number, suspended: number }}
 *   onChange  {(status: string) => void}
 */

const TABS = [
  { key: 'pending_verification', label: 'En attente' },
  { key: 'verified', label: 'Vérifiés' },
  { key: 'suspended', label: 'Suspendus' },
];

const StatusTabs = ({ active, counts = {}, onChange }) => {
  return (
    <div className="flex gap-1 border-b border-gray-200 mb-6">
      {TABS.map((tab) => {
        const isActive = active === tab.key;
        const count = counts[tab.key] ?? 0;
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={[
              'px-4 py-2 text-sm font-montserrat font-medium border-b-2 -mb-px transition-colors',
              isActive
                ? 'border-[#17386E] text-[#17386E]'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            ].join(' ')}
            aria-selected={isActive}
            role="tab"
          >
            {tab.label}
            <span
              className={[
                'ml-2 inline-flex items-center justify-center rounded-full text-xs px-2 py-0.5',
                isActive
                  ? 'bg-[#17386E] text-white'
                  : 'bg-gray-100 text-gray-600',
              ].join(' ')}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default StatusTabs;
